import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import withMessages from '../../utilities/intl';

import DropdownItem from './SplitViewTagActionDropdownItem';

import styles from './splitview.scss';
import './SplitViewTagAction.scss';

const BASE_KEY = 'components.split_view.review';

function SplitViewTagActionComponent({
    getMessage,
    reviewStatuses,
    onSelect,
    isProcessing,
    disabled,
    shouldRenderMessage,
}) {
    return (<div className={styles.dropdown}>
        <span className={styles[`${!shouldRenderMessage ? 'table-tag' : ''}`]}>
            <span className={styles[`action-tags${isProcessing || disabled ? '-inactive' : ''}`]}>
                {!shouldRenderMessage && getMessage(`${BASE_KEY}.tag`)}
            </span>
        </span>
        {(!isProcessing && !disabled) && (
            <span className={styles['dropdown-box']}>
                <span className={styles['dropdown-menu-white']}>
                    <DropdownItem
                        getMessage={getMessage}
                        onClick={() => onSelect(reviewStatuses.NEEDS_REVIEW)}
                        itemKey="needs-review"
                    />
                    <DropdownItem
                        getMessage={getMessage}
                        onClick={() => onSelect(reviewStatuses.REVIEWED)}
                        itemKey="reviewed"
                    />
                    <DropdownItem
                        getMessage={getMessage}
                        onClick={() => onSelect(reviewStatuses.NO_REVIEW_STATE)}
                        itemKey="remove"
                    />
                </span>
            </span>
        )}
    </div>)
}

SplitViewTagActionComponent.propTypes = {
    getMessage: PropTypes.func.isRequired,
    reviewStatuses: PropTypes.object,
    onSelect: PropTypes.func,
    isProcessing: PropTypes.bool,
    disabled: PropTypes.bool,
    shouldRenderMessage: PropTypes.bool,
};

SplitViewTagActionComponent.defaultProps = {
    reviewStatuses: {},
    onSelect: () => {},
    isProcessing: true,
    disabled: false,
    shouldRenderMessage: false,
};

const SplitViewTagAction = withMessages(SplitViewTagActionComponent);
SplitViewTagAction.displayName = displayName('SplitView/SplitViewTagAction');

export default SplitViewTagAction;
